import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a
              href="/"
              className="flex items-center gap-2 text-foreground-950 mb-4 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">
                Kakobuy<span className="text-primary-600">Polska</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Największa polska baza wiedzy o Kakobuy Spreadsheet. Znajdź najlepsze produkty, poradniki i analizy bezpieczeństwa.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              Szybkie Linki
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  Strona Główna
                </a>
              </li>
              <li>
                <a href="#bezpieczenstwo" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  Bezpieczeństwo
                </a>
              </li>
              <li>
                <a href="#blog" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  Blog
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              Kategorie
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              Więcej Kategorii
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} KakobuyPolska.skin. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Kup Teraz
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}